import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";

import constants, { getOnboardingPath } from "../../../../constants";
import * as actions from "../../../../store/actions";

import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import Col from "../../../../components/uiElements/grid/Col";
import Button from "../../../../components/formElements/button/Button";
import Themes from "./Themes";
import PersonalisedLogoInput from "../../../../components/formElements/file/PersonalisedLogoInput";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import OneTimePaymentModal from "./OneTimePaymentModal";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const StepFour = ({
  personalisedExperience,
  setPersonalisedExperience,
  history,
  redirectedPath,
  updateDoctorAppTheme,
  deleteFileFromS3,
  payPersonlizedExperience,
  updateDoctorPaidDetails,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onFileError = error => {
    toast.error(error, {
      position: constants.TOAST_POSITION,
    });
  };

  return (
    <>
      <Elements stripe={stripePromise}>
        <OneTimePaymentModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          onPayment={payPersonlizedExperience}
          onPaymentSuccess={updateDoctorPaidDetails}
          price="1"
          allowBankDebit={false}
          title="Personalise Experience"
        />
      </Elements>
      <div className={classnames("onboarding-container")}>
        <p className="onboarding-header">Personalise Experience</p>
        <Row>
          <p className="text-justify w-75">
            Give personalised experience to your patients by uploading your logo
            and selecting your theme colour.
          </p>
          <Col size={["md-12"]}>
            <Card
              style={{
                height: 248,
              }}
              className={classnames("ml-n3")}
            >
              <PersonalisedLogoInput
                showPreview
                buttonClass="w-100"
                name="logo"
                files={personalisedExperience.logo}
                onChange={files => setPersonalisedExperience(files)}
                onError={error => onFileError(error)}
                onRemove={file =>
                  deleteFileFromS3(file, () => updateDoctorAppTheme("update"))
                }
                title="Upload Logo"
              />
            </Card>

            <Card
              title="Select Theme"
              style={{
                height: 420,
              }}
              className={classnames("ml-n3")}
            >
              <Themes
                personalisedExperience={personalisedExperience}
                setPersonalisedExperience={setPersonalisedExperience}
              />
            </Card>
          </Col>
          <Col className="ml-n5">
            {!personalisedExperience?.is_paid ? (
              <Button
                type="info"
                className={classnames("w-75 mb-4 mr-n5")}
                onClick={() => setIsOpen(true)}
                label={"Pay $1"}
              />
            ) : (
              <Button
                type="info"
                className={classnames("w-75 mb-4 mr-n5")}
                onClick={() =>
                  personalisedExperience?.id
                    ? updateDoctorAppTheme("update")
                    : updateDoctorAppTheme("save")
                }
                label={"Save Changes"}
              />
            )}

            {!redirectedPath && (
              <Button
                type="secondary"
                indicatorButton
                className={classnames("float-right next-button")}
                onClick={() => history.push(getOnboardingPath("/step6"))}
                label={<OnboardingIcon type="nextButton" />}
              />
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth }) => ({
  personalisedExperience: onboarding.personalisedExperience,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  setPersonalisedExperience: updatedData =>
    dispatch(actions.setPersonalisedExperience(updatedData)),
  updateDoctorAppTheme: (action, cb) =>
    dispatch(actions.updateDoctorAppTheme(action, cb)),
  deleteFileFromS3: (file, cb) => dispatch(actions.deleteFileFromS3(file, cb)),
  payPersonlizedExperience: cb =>
    dispatch(actions.payPersonlizedExperience(cb)),
  updateDoctorPaidDetails: cb => dispatch(actions.updateDoctorPaidDetails(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepFour)
);
